import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

import { Message } from '@frontend/sports/betting-offer/feature/model';

@Component({
    selector: 'ms-scoreboard-message',
    templateUrl: 'scoreboard-message.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ScoreboardMessageComponent {
    @Input() message: Message;

    @HostBinding('class') className = 'scoreboard-message';

    @HostBinding('class.highlight')
    get highlight(): boolean {
        return !!this.message.icon && !!this.message.icon.highlight;
    }

    get color(): string | undefined {
        if (!this.message.icon!.color) {
            return;
        }

        return this.message.icon!.color.replace('color', '').replace('icon', '').toLowerCase();
    }
}
